export default __webpack_public_path__ + "static/media/fill.83e61216.svg";